define('environments/production',{
  env: "production",
  defaultDomain: "https://signup.mdirector.com/",
  backendUrl: "https://signup-backend.mdirector.com",
  mdirectorUrl: "https://www.mdirector.com",
  mdirectorPrivateUrl: "https://www.mdirector.com/private?redirect=dashboard",
  landingsUrl: "https://landings.mdirector.com",
  transUrl: "https://trans.mdirector.com",
  automationUrl: "https://automation.mdirector.com",
  authUrl: "https://auth.mdirector.com",
  paymentsUrl: "https://payments.mdirector.com/",
  captchaPublicKey: "6LeP380UAAAAANdkQPCqAs8UGGhwoti0x7Pjg8Mc",
  i18nCookieDomain: ".mdirector.com",
  getProvincesUrl: "https://signup-backend.mdirector.com/provinces/country/",
  getCountriesUrl: "https://signup-backend.mdirector.com/countries",
  getUserDataUrl: "https://signup-backend.mdirector.com/signup/",
  getUserServicesUrl:
    "https://signup-backend.mdirector.com/user-services/hash/",
  postUserServicesUrl: "https://signup-backend.mdirector.com/user-services",
  submitUrl: "https://signup-backend.mdirector.com/signup",
  themeAssetsUrl: "https://static.mdirector.com/assets/themes/",
  showTransArray: [
    "30531",
    "66848",
    "2823",
    "63454",
    "77583",
    "77585",
    "77546",
    "30311",
    "78594",
  ],
  showBalanceArray: [
    "1792",
    "1850",
    "2283",
    "3549",
    "4258",
    "5722",
    "11182",
    "29456",
    "29457",
    "29457",
    "30411",
    "30411",
    "30715",
    "31667",
    "32521",
    "36725",
    "37450",
    "37975",
    "39050",
    "43097",
    "46155",
    "46155",
    "52954",
    "53058",
    "53455",
    "54079",
    "61113",
    "62522",
    "62780",
    "74159",
    "74334",
    "74532",
    "77147",
    "77527",
    "78003",
    "83031",
    "83072",
    "84669",
    "85760",
    "85870",
    "86448",
    "89352",
    "90334",
    "90783",
    "98852",
    "111784",
    "115197",
  ],
  registerUrl: {
    es: "https://www.mdirector.com/signup/",
    fr: "https://www.mdirector.com/fr/signup/",
    it: "https://www.mdirector.com/it/signup/",
    pt: "https://www.mdirector.com/pt/signup/",
    en: "https://www.mdirector.com/en/signup/",
  },
  ga: {
    ua: "UA-38466648-2",
    collectUrl: "https://www.google-analytics.com/collect?v=1",
    tagmanagerId: "GTM-WX6H3W",
    domain: "mdirector.com",
  },
  trackingFirstStepDefaultParams: {
    origin: "web",
    service: "mdirector",
    productId: "emailmarketing",
    productName: "Email Marketing",
    landingName: "No_LANDING_Direct_Registry",
  },
  securityOptionsAllowGroups: [],
  SECURE_PASSWORD_LENGTH: 8,
  SECURE_PASSWORD_MAX_LENGTH: 64,
  maintenanceUrl: "https://static.mdirector.com/assets/js/maintenance.js",
  CPSAgreements: {
    cookieDismissName: "CPSAgreementsDismiss",
    cookieDismissValue: "ok",
    cookieDismissExpirationDays: 1,
    externalTermsURL: {
      es: "https://pmp.antevenio.com/mdirector/cps-mdirector-esp-es",
      en: "https://pmp.antevenio.com/mdirector/cps-mdirector-eng-es",
      it: "https://pmp.antevenio.com/mdirector-it/md-cps-it",
    },
    canBeDelayed: false,
  },
  integrations: {
    zapierEnabled: true,
    shopifyEnabled: true,
    APIsEnabled: true,
  },
});

